import axios from 'axios';
import Cookies from 'js-cookie';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

api.interceptors.response.use(
  res => res,
  err => {
    const status401    = err.response?.status === 401;
    const authFalse    = err.response?.data?.auth === false;

    if (status401 || authFalse) {
      // 1) Remove the exact cookie you set:
      Cookies.remove('token', {
        path:     '/',                    // match your app
        domain:   window.location.hostname.includes('liaplus.com')
                  ? '.liaplus.com'       // only if you set domain=.liaplus.com
                  : window.location.hostname,
        secure:   true,
        sameSite: 'None',
      });

      // 2) Clear local/session storage
      localStorage.clear();
      sessionStorage.clear();

      // 3) Redirect once, without leaving a back-button trap
      window.location.replace('/login');
      window.location.reload();
    }

    return Promise.reject(err);
  }
);

export default api;
